import React from 'react';
import { updateProductHistory, updateResponse, getBranches, getProductHistoryById } from "../../api/productHistoryapi";
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Form, Input, Label, Button, Row, Col, InputGroup } from 'reactstrap';
import 'react-quill/dist/quill.snow.css';
import CustomDatePicker from '../CustomDatePicker';
import FormValidator from '../FormValidation';
import cloneDeep from 'lodash/cloneDeep';
import { formatInTimeZoneDate, formatInTimeZoneDateTime } from '../../helpers';
import PopupError from '../PopupError';
import CardTitle from '../CardTitle';
import { updateRedirect } from './../../helpers/redirect';
import '../css/EditCreate.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'reactstrap';

class ProductHistoryEdit extends React.Component {

    constructor(props) {
        super(props);
        if (this.props.route.location.state) {
            if (this.props.route.location.state.from === 'gift') {
                this.props.route.history.push('/secure/gifts');
                this.props.route.history.push(this.props.route.match.url);
            }
            if (this.props.route.location.state.from === 'giftEdit') {
                this.props.route.history.push(`/secure/giftEdit/${this.props.route.location.state.id}`);
                this.props.route.history.push(this.props.route.match.url);
            }
        }
        this.validator = new FormValidator([
            {
                field: 'name',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'displayName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'cost',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'branchName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'towing',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'startDate',
                method: this.isBefore,
                validWhen: true,
                message: 'Start date must be before end date.'
            }
        ]);
        let productHistory = null;
        if (this.props.route.state)
            if (this.props.route.state.productHistory)
                productHistory = this.props.route.state.productHistory;
        this.state = {
            readOnly: true,
            productHistory: productHistory,
            cancel: false,
            saved: false,
            error: false,
            edit: false,
            tooltipOpen: false,
            validation: this.validator.valid(),
            baseState: '',
            branches: [],
            errorMessage: [],
            productHistoryId: this.props.route.match.params.productHistoryId ? this.props.route.match.params.productHistoryId : ''
        };

        this.closeModal = this.closeModal.bind(this);
    }
    isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate);
    isAfter = (confirmation, state) => (state.startDate <= confirmation);

    componentDidMount() {
        this.props.getBranches(function (result, _this) { _this.getData(result, _this) }, this)
        const productHistoryId = this.props.route.match.params.id;
        this.props.getProductHistoryById(function (result, _this) { _this.getDataProductHistory(result, _this) }, this, productHistoryId)
    }

    getDataProductHistory(data, _this) {
        var x = JSON.stringify(cloneDeep(data.data.data))
        _this.setState({
            productHistory: data.data.data,
            baseState: x,
            _startDate: !data.data.data.startDate ? '' : formatInTimeZoneDate(data.data.data.startDate, data.data.data.branchIanaTimeZoneId),
            _endDate: !data.data.data.endDate ? '' : formatInTimeZoneDate(data.data.data.endDate, data.data.data.branchIanaTimeZoneId)
        })
    }

    componentDidUpdate(prevProps) {
        //Checks if there is a response on update
        if (this.props.updateResult !== prevProps.updateResult) {
            console.log("a response exists");
            var result = this.props.updateResult
            console.log(result, "this is the result");
            //Checks if the response is success or has errors.
            if (result) {
                if (result.data.success) {
                    console.log(result.data.success);
                    var x = JSON.stringify(cloneDeep(this.state.productHistory));
                    this.setState(state => ({
                        baseState: x,
                        saved: true,
                        edit: false,
                        validation: this.validator.valid(),
                        readOnly: !state.readOnly,
                        _startDate: !state.productHistory.startDate ? '' : formatInTimeZoneDate(state.productHistory.startDate + "T00:00:00", state.productHistory.branchIanaTimeZoneId),
                        _endDate: !state.productHistory.endDate ? '' : formatInTimeZoneDate(state.productHistory.endDate + "T00:00:00", state.productHistory.branchIanaTimeZoneId)
                    }));
                    this.props.getProductHistoryById(function (result, _this) { _this.getDataProductHistoryById(result, _this) }, this, this.state.productHistory.productHistoryId)
                } else if (result.data.success === false) {
                    var errorList = [];
                    // eslint-disable-next-line array-callback-return
                    result.data.errors.map(function (e) { errorList.push(e.message) })
                    this.setState({ error: true, errorMessage: errorList })
                }
                else {
                    let message = Object.keys(result.data.errors).map((function (e) { return 'there was an error saving ' + e }));
                    this.setState({ error: true, errorMessage: message });
                }
                this.props.updateResponse("");
            }
        }
    }

    toggleTooltip = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    renderBranchNames() {
        let branches = this.state.branches;
        return branches.map((branch) => {
            return (
                <option id={branch.branchId} key={branch.branchId}>{branch.name}</option>
            );
        });
    }

    getData(data, _this) {
        _this.setState({
            branches: data.data.data,
            loading: false
        });
    }

    handleCancel = () => {
        this.setState({
            cancel: true
        })
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    closeModal() {
        this.setState({ error: false });
        this.submitted = false;
    }

    render() {
        const productHistory = this.state.productHistory;
        //Redirects to productHistory when canceled
        if (this.state.cancel) {
            this.props.currentNavigationConnect({
                isOpen: false,
                selected: "gifts",
                selectedAdmin: ''
            });
            return <Redirect
                to={{
                    pathname: `/secure/gifts`,
                }}
            />;
        }

        let validation = this.submitted ?                         // if the form has been submitted at least once
            this.validator.validate(this.state.productHistory) :   // then check validity every time we render
            this.state.validation                   // otherwise just use what's in state

        console.log(validation, "validation result");
        if (document.querySelector('.nativeDatePicker')) document.querySelector('.nativeDatePicker').style.display = 'none';
        return (
            <div className="card">

                <PopupError
                    open={this.state.error}
                    onClose={this.closeModal}
                    onClick={this.closeModal}
                    errorMessage={this.state.errorMessage} />

                <CardTitle
                    component={"Product"}
                    readOnly={this.state.readOnly} />

                {productHistory && <div className="card-body fs-12">
                    <Form onSubmit={this.handleSubmit}>
                        <div className="row">
                            <div className="col-md-12">
                                <Col>
                                    <Row>
                                        <Col className={`${validation.name.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                            <Label className="required-hint mt-4"><strong>Product Level</strong></Label>
                                            <Input readOnly={this.state.readOnly}
                                                type="input"
                                                name="name"
                                                className={this.state.readOnly ? '' : 'input-editable'}
                                                maxLength="150"
                                                required={this.submitted}
                                                title=""
                                                value={productHistory.name}
                                                onChange={(e) => { this.isInvalid(e); var x = productHistory; x.name = e.target.value; this.setState({ productHistory: x }) }} />
                                            <span className="help-block">{validation.name.message}</span>
                                        </Col>
                                        <Col className={`${validation.branchName.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                            <Label className="required-hint mt-4"><strong>Branch</strong></Label>
                                            <label className={this.state.readOnly ? 'select-disabled' : 'select'}>
                                                <select
                                                    name="branchName"
                                                    className={this.state.readOnly ? 'form-control' : 'input-editable form-control'}
                                                    value={productHistory.branchName}
                                                    required={this.submitted}
                                                    title=""
                                                    disabled={this.state.readOnly}
                                                    onChange={(e) => {
                                                        var x = this.state.productHistory; x.branchName = e.target.value;
                                                        var y = this.state.productHistory; y.branchId = e.target[e.target.selectedIndex].getAttribute('id');
                                                        // eslint-disable-next-line no-dupe-keys
                                                        this.setState({ branch: x, branch: y })
                                                    }}
                                                >
                                                    {this.renderBranchNames()}
                                                </select><span className="help-block">{validation.branchName.message}</span>
                                            </label>
                                        </Col>
                                        <Col className={`${validation.displayName.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                            <Label className="required-hint mt-4"><strong>Product-Branch Display Name</strong></Label>
                                            <Input readOnly={this.state.readOnly}
                                                type="input"
                                                name="displayName"
                                                className={this.state.readOnly ? '' : 'input-editable'}
                                                maxLength="150"
                                                required={this.submitted}
                                                title=""
                                                value={productHistory.displayName}
                                                onChange={e => {
                                                    this.isInvalid(e)
                                                    const value = e.target.value;
                                                    this.setState(prevState => ({ productHistory: { ...prevState.productHistory, displayName: value } }))
                                                }} />
                                            <span className="help-block">{validation.displayName.message}</span>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                            <div className="col-md-12">
                                <Col>
                                    <Label className="required-hint mt-4"><strong>Short Description</strong></Label>
                                    {this.state.readOnly && <div style={{ borderStyle: "none" }} className="ql-container ql-snow reactquill-field-smaller editor-readonly">
                                        <div className='ql-editor' dangerouslySetInnerHTML={{ __html: productHistory.shortDescription }}></div>
                                    </div>}
                                    <span className="help-block"></span>
                                </Col>
                                <Col>
                                    <Label className="required-hint mt-4"><strong>Long Description</strong></Label>
                                    {this.state.readOnly && <div style={{ borderStyle: "none" }} className="ql-container ql-snow reactquill-field editor-readonly">
                                        <div className='ql-editor' dangerouslySetInnerHTML={{ __html: productHistory.longDescription }}></div>
                                    </div>}
                                    <span className="help-block"></span>
                                </Col>
                                <Col>
                                    <Label className='mt-4'><strong>Legal Disclosure</strong></Label>
                                    {this.state.readOnly && <div style={{ borderStyle: "none", marginBottom: 22 }} className="ql-container ql-snow reactquill-field-smaller editor-readonly">
                                        <div className='ql-editor' dangerouslySetInnerHTML={{ __html: productHistory.legalDisclosure }}></div>
                                    </div>}
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <Row form>
                                        <Col style={{ marginBottom: 17 }}>
                                            <Label className="required-hint mt-4"><strong>Towing Miles</strong></Label>
                                            <Input readOnly={this.state.readOnly}
                                                type="input"
                                                maxLength="2000"
                                                required
                                                className={this.state.readOnly ? '' : 'input-editable'}
                                                value={productHistory.towing}
                                                onChange={(e) => { var x = productHistory; x.towing = e.target.value; this.setState({ productHistory: x }) }} />
                                            <span className="help-block">{validation.towing.message}</span>
                                        </Col>
                                        <Col>
                                            <Label className="required-hint mt-4"><strong>Service Calls per Year</strong></Label>
                                            <Input readOnly={this.state.readOnly}
                                                type="input"
                                                name="entitlement"
                                                maxLength="150"
                                                className={this.state.readOnly ? '' : 'input-editable'}
                                                value={productHistory.entitlements}
                                                onChange={(e) => { var x = productHistory; x.entitlements = e.target.value; this.setState({ productHistory: x }) }} />
                                            <span className="help-block"></span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Label className="required-hint mt-4"><strong>Battery Service</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        name="battery"
                                        maxLength="500"
                                        onChange={(e) => { var x = productHistory; x.battery = e.target.value; this.setState({ productHistory: x }) }}
                                        value={productHistory.battery} />
                                    <span className="help-block"></span>
                                </Col>
                                <Col >
                                    <Label className="required-hint mt-4"><strong>Lockout Service</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        name="lockOut"
                                        maxLength="500"
                                        onChange={(e) => { var x = productHistory; x.lockout = e.target.value; this.setState({ productHistory: x }) }}
                                        value={productHistory.lockout} />
                                    <span className="help-block"></span>
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <Label className="mt-4"><strong>Towing Miles Exception</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        style={{ height: 52 }}
                                        type="textarea"
                                        name="mileageExcpetion"
                                        maxLength="150"
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        value={productHistory.mileageException}
                                        onChange={(e) => { var x = productHistory; x.mileageException = e.target.value; this.setState({ productHistory: x }) }} />
                                    <span className="help-block"></span>
                                </Col>
                                <Col>
                                    <Label className="required-hint mt-4"><strong>Flat Tire Change</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        name="flat"
                                        maxLength="500"
                                        onChange={(e) => { var x = productHistory; x.flat = e.target.value; this.setState({ productHistory: x }) }}
                                        value={productHistory.flat} />
                                    <span className="help-block"></span>
                                </Col>
                                <Col>
                                    <Label className="required-hint mt-4"><strong>Fuel Delivery</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        name="fuel"
                                        maxLength="500"
                                        onChange={(e) => { var x = productHistory; x.fuel = e.target.value; this.setState({ productHistory: x }) }}
                                        value={productHistory.fuel} />
                                    <span className="help-block"></span>
                                </Col>
                            </div>
                            <div className="col-md-12">
                                <hr style={{ border: '1.4px solid #4798d2', marginTop: '1.5rem !important', marginBottom: 0, width: '97%' }} />
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <Row>
                                        <Col className={`${validation.cost.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                            <Label className="required-hint mt-4"><strong>Price</strong></Label>
                                            <InputGroup>
                                                <div className="input-group-prepend">
                                                    <span className={this.state.readOnly ? "input-group-text noborder" : "input-group-text currency-span"}>
                                                        $
                                                    </span>
                                                </div>
                                                <Input readOnly={this.state.readOnly}
                                                    type="input"
                                                    name="price"
                                                    className={this.state.readOnly ? '' : 'input-editable'}
                                                    maxLength="150"
                                                    required
                                                    title=""
                                                    value={productHistory.cost.toFixed(2)}
                                                    onChange={(e) => { this.isInvalid(e); var x = productHistory; x.cost = e.target.value; this.setState({ productHistory: x }) }} />
                                            </InputGroup>
                                            <span className="help-block">{validation.cost.message}</span>
                                        </Col>
                                        <Col>
                                            <Label className="required-hint mt-4"><strong>Enrollment Fee</strong></Label>
                                            <InputGroup>
                                                <div className="input-group-prepend">
                                                    <span className={this.state.readOnly ? "input-group-text noborder" : "input-group-text currency-span"}>
                                                        $
                                                    </span>
                                                </div>
                                                <Input readOnly={this.state.readOnly}
                                                    type="input"
                                                    name="enrollmentFee"
                                                    className={this.state.readOnly ? '' : 'input-editable'}
                                                    maxLength="150"
                                                    value={productHistory.enrollmentFee.toFixed(2)}
                                                    onChange={(e) => { var x = productHistory; x.enrollmentFee = e.target.value; this.setState({ productHistory: x }) }} />
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col style={{ marginBottom: 50 }}>
                                    <Row>
                                        <Col>
                                            <Label className="mt-4">
                                                <strong>
                                                    Price per Associate{' '}
                                                    <FontAwesomeIcon
                                                        id="priceInfo"
                                                        icon={faInfoCircle}
                                                        className="text-info purple-tooltip"
                                                    />
                                                </strong>
                                            </Label>
                                            <Tooltip
                                                placement="top"
                                                isOpen={this.state.tooltipOpen}
                                                target="priceInfo"
                                                toggle={this.toggleTooltip}
                                            >
                                                To disable Associates on this product, set price to $0.
                                            </Tooltip>
                                            <InputGroup>
                                                <div className="input-group-prepend">
                                                    <span className={this.state.readOnly ? "input-group-text noborder" : "input-group-text currency-span"}>
                                                        $
                                                    </span>
                                                </div>
                                                <Input readOnly={this.state.readOnly}
                                                    type="number"
                                                    className={this.state.readOnly ? '' : 'input-editable'}
                                                    maxLength="150"
                                                    step="0.01"
                                                    min="0"
                                                    value={this.state.readOnly ? parseFloat(productHistory.costPerAssociate).toFixed(2) : productHistory.costPerAssociate}
                                                    onBlur={(e) => { e.target.value = parseFloat(e.target.value).toFixed(2); var x = productHistory; x.costPerAssociate = e.target.value; this.setState({ productHistory: x }) }}
                                                    onChange={(e) => { var x = productHistory; x.costPerAssociate = e.target.value; this.setState({ product: x }) }} />
                                            </InputGroup>
                                        </Col>
                                        <Col>
                                            <Label className="required-hint mt-4"><strong>Free Associates</strong></Label>
                                            <Label className={this.state.readOnly ? 'select-disabled' : 'select'}>
                                                <select
                                                    name="freeAss"
                                                    className={this.state.readOnly ? 'form-control' : 'input-editable form-control'}
                                                    value={this.state.readOnly ? parseInt(productHistory.freeAssociatesAllowedNumber) : productHistory.freeAssociatesAllowedNumber}
                                                    disabled={this.state.readOnly}
                                                    onChange={(e) => { this.isInvalid(e); var x = productHistory; x.freeAssociatesAllowedNumber = e.target.value; this.setState({ product: x }) }}>
                                                    <option>0</option>
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                    <option>4</option>
                                                    <option>5</option>
                                                </select>
                                            </Label>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                            <div className="col-md-12">
                                <hr style={{ border: '1.4px solid #4798d2', marginTop: 0, marginBottom: 0, width: '97%' }} />
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    {!this.state.readOnly && <Row form>
                                        <Col className={`${validation.startDate.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                            <Label className="mt-4"><strong>Start Date</strong></Label>
                                            <CustomDatePicker
                                                id="startDate"
                                                readOnly={this.state.readOnly}
                                                defValue={!productHistory.startDate ? "" : productHistory.startDate.substring(0, 10)}
                                                label="Start Date"
                                                overlayClass="location-datepicker-overlay"
                                            />
                                            <span className="help-block-calendar">{validation.startDate.message}</span>
                                        </Col>
                                        <Col>
                                            <Label className="mt-4"><strong>End Date</strong></Label>
                                            <CustomDatePicker
                                                id="endDate"
                                                readOnly={this.state.readOnly}
                                                defValue={!productHistory.endDate ? "" : productHistory.endDate.substring(0, 10)}
                                                label="End Date"
                                                overlayClass="location-datepicker-overlay"
                                            />
                                            <span className="help-block"></span>
                                        </Col>
                                    </Row>}

                                    {this.state.readOnly &&
                                        <Row>
                                            <Col>
                                                <Label className="mt-4"><strong>Start Date</strong></Label>
                                                <Input
                                                    id="_startDate"
                                                    readOnly={true}
                                                    className=''
                                                    value={this.state._startDate}>
                                                </Input>

                                            </Col>
                                            <Col>
                                                <Label className="mt-4"><strong>End Date</strong></Label>
                                                <Input
                                                    id="_endDate"
                                                    readOnly={true}
                                                    className=''
                                                    value={this.state._endDate}>
                                                </Input>
                                            </Col>
                                        </Row>
                                    }
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <div className="text-right float-bottom">
                                        <Button onClick={this.handleCancel.bind(this)} className="cancel-btn">CANCEL</Button>
                                    </div>
                                </Col>
                            </div>
                        </div>
                    </Form>
                    {/* Divider */}
                    <Col>
                        <hr />
                    </Col>
                    <Col>
                        <Row>
                            <div className="col-md-1">
                                <label><strong>ID</strong></label>
                                <p className="editFooterText">{productHistory.productHistoryId}</p>
                            </div>
                            <div className="col-md-3">
                                <label><strong>Created by</strong></label>
                                <p className="editFooterText">{productHistory.createdBy}</p>
                            </div>
                            <div className="col-md-3">
                                <label><strong>Created date</strong></label>
                                <p className="editFooterText">{formatInTimeZoneDateTime(productHistory.createdDate, productHistory.branchIanaTimeZoneId)}</p>
                            </div>
                            <div className="col-md-2">
                                <label><strong>Updated by</strong></label>
                                <p className="editFooterText">{productHistory.updatedBy}</p>
                            </div>
                            <div className="col-md-3">
                                <label><strong>Updated date</strong></label>
                                <p className="editFooterText">{formatInTimeZoneDateTime(productHistory.updatedDate, productHistory.branchIanaTimeZoneId)}</p>
                            </div>
                        </Row>
                    </Col>
                </div>}
            </div>
        );
    }

}

export default connect(
    state => {
        return {
            updateResult: state.data.updateResult,
            branches: state.data.branches
        }
    },
    dispatch => ({
        getProductHistoryById: (callback, context, id) => { dispatch(getProductHistoryById(callback, context, id)) },
        getBranches: (callback, context) => { dispatch(getBranches(callback, context)) },
        updateProductHistory: (callback, context) => { dispatch(updateProductHistory(callback, context)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) },
        currentNavigationConnect: (response) => { dispatch(updateRedirect(response)) }
    }
    )
)(ProductHistoryEdit);